
import { Component, Prop, Vue } from 'vue-property-decorator';
import SvgOpenLink from'@/assets/icons/open-link.svg';
import SvgCopy from "@/assets/icons/copy2.svg";
import { OfferSingle } from '@/services/offers/OfferSingle';
import BaseCard from "@/components/base/BaseCard.vue";
import BaseListV2 from "@/components-UI/list/BaseListV2.vue";
import BaseChip from "@/components-UI/BaseChip.vue";
import BaseTooltip from "@/components-UI/BaseTooltip.vue";
import BaseButton from "@/components-UI/BaseButton.vue";
import router from "@/router";
import { useCopyText } from "@/utils/copyText";
import { useOfferDetailStore } from "@/store_v3/offerCard";

@Component({
    components: {
        BaseChip,
        BaseListV2,
        BaseCard,
        SvgOpenLink,
        SvgCopy,
        BaseTooltip,
        BaseButton,
    },
})

export default class GoalTracking extends Vue {
    @Prop({ required: true }) offer!: OfferSingle | null;
    @Prop({ required: true }) goal!: any;

    useOfferCardStore = useOfferDetailStore();

    get getOptions(): {
        name: string;
        value: string;
        type: string; //'copy-text' | 'pixel-code' | 'doc';
        hint: boolean;
        labelSlot: string;
        valueSlot: string;
    }[] {
        const baseOptions = [
            {
                name: 'Тестовая ссылка',
                value: `https://${this.useOfferCardStore.prepareTrackingDomain(this.offer)}/aff_c?aff_id=1&offer_id=${this.offer?.legacy_id}`,
                type: 'copy-link',
                hint: true,
                labelSlot: 'name',
                valueSlot: 'value',
            },
        ];
        const postbackOptions = [
            {
                name: 'Расширенный постбек (RU)',
                value: 'https://docs.google.com/document/d/1ck6-6SBAOyYWmFz--_NAaeN479kdhYMoFS7c50k7a5o/edit?usp=sharing',
                type: 'doc',
                hint: false,
                labelSlot: 'name',
                valueSlot: 'value',
            },
            {
                name: 'Расширенный постбек (EN)',
                value: 'https://docs.google.com/document/d/1czuJMEillBjV-Zqd0jF7oOgqLps1BeRf/edit?tab=t.0',
                type: 'doc',
                hint: false,
                labelSlot: 'name',
                valueSlot: 'value',
            },
            {
                name: 'Простой постбек',
                value: this.getPostbackLink,
                type: 'copy-link',
                hint: false,
                labelSlot: 'name',
                valueSlot: 'value',
            },
        ];
        const pixelOptions = [
            {
                name: 'Код пикселя',
                value: this.getPostbackLink,
                type: 'pixel-code',
                hint: false,
                labelSlot: 'name',
                valueSlot: 'value',
            },
        ];

        if (this.goal?.protocol === 'pixel') {
            return [...baseOptions, ...pixelOptions];
        }

        return [...baseOptions, ...postbackOptions];
    }

    get getPostbackLink(): string {
        if (!this.goal) {
            return "";
        }

        if (this.goal.protocol === 'postback' && this.offer) {
            const baseUrl = "https://go.leadgid.com";
            let url = '';

            if (this.goal.legacy_id === 0) {
                // Если цель нулевая, используем ID оффера
                url = `${baseUrl}/aff_lsr?offer_id=${this.offer.legacy_id}&adv_sub=SUB_ID&transaction_id=TRANSACTION_ID`;
            } else {
                // Если цель не нулевая, используем ID цели
                url = `${baseUrl}/aff_goal?a=lsr&goal_id=${this.goal.legacy_id}&transaction_id=TRANSACTION_ID`;
            }

            return url;
        } else if (this.goal.protocol === 'pixel' && this.offer){
            let img = '';

            if (this.goal.legacy_id === 0) {
                // Если цель нулевая, используем ID оффера
                img = `<img src="https://${this.offer.tracking_domain?.domain}/aff_l?offer_id=${this.offer.legacy_id}&adv_sub=SUB_ID" width="1" height="1" />`;
            } else {
                // Если цель не нулевая, используем ID цели
                img = `<img src="https://${this.offer.tracking_domain?.domain}/aff_goal?a=l&goal_id=${this.goal.legacy_id}&adv_sub=SUB_ID" width="1" height="1" />`;
            }
            return img;
        } else {
            return "";
        }
    }

    async copyUrl(value: string): Promise<void> {
        try {
            let link = '';
            if (this.goal && this.goal.protocol === 'pixel') {
                if (this.goal.legacy_id === 0) {
                    link = `<!-- Offer Conversion: ${this.offer?.name} -->` + this.getPostbackLink + `<!-- // End Offer Conversion -->`;
                } else {
                    link = `<!-- Offer Goal Conversion: ${this.offer?.name} -->` + this.getPostbackLink + `<!-- // End Offer Conversion -->`;
                }
            } else {
                link = value;
            }

            useCopyText(link);
        } catch (err) {
            console.error('Ошибка при копировании: ', err);
        }
    }

    goToDetailThisOffer(): void {
        if (this.offer && this.offer.legacy_id && this.offer.id) {
            router.push({
                name: 'offer',
                params: {
                    id: this.offer.legacy_id ? String(this.offer.legacy_id) : String(this.offer.id),
                },
                query: {
                    tab: 'tab-links',
                },
            });
        }
    }
}
